import { BasicModal, Button } from '@life-line-lab/components-react';
import { Space } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ProceedPaymentModalProps {
  payNowPopup: boolean;
  onCloseModal: () => void;
  confirmPay: React.MouseEventHandler<HTMLButtonElement>;
}

export const ProceedPaymentModal = ({
  payNowPopup,
  onCloseModal,
  confirmPay,
}: ProceedPaymentModalProps) => {
  const { t } = useTranslation();

  return (
    <BasicModal
      title={t('title.proceedToPayment')}
      isClosable={true}
      isMaskClosable={true}
      isOpen={payNowPopup}
      onClose={onCloseModal}
    >
      <div className="cancel-modal">
        <Space direction="vertical" size="middle">
          <h2 className="main-title">{t('txt.proceedPaymentForOrder')}</h2>
        </Space>

        <div className="mt-10">
          <Button
            type="default"
            className="cancel-button"
            label={
              <React.Fragment>
                <span>{t('action.back')}</span>
              </React.Fragment>
            }
            size="large"
            onClick={onCloseModal}
          />
          <Button
            type="primary"
            label={
              <React.Fragment>
                <span>{t('action.continue')}</span>
              </React.Fragment>
            }
            size="large"
            onClick={confirmPay}
          />
        </div>
      </div>
    </BasicModal>
  );
};
